import {
  mdiWeb,
  mdiHomeOutline,
  mdiPageLayoutHeader,
  mdiPageLayoutFooter,
  mdiAccountMultipleOutline,
  mdiCog,
  mdiDockWindow,
  mdiPageLayoutSidebarRight,
  mdiViewGridOutline,
  mdiHelpBoxOutline,
  mdiArrangeBringForward,
  mdiCalendarMonthOutline,
  mdiBrain,
  mdiFormSelect,
  mdiViewDay,
  mdiPhonePlus,
  mdiShapeOutline,
} from "@mdi/js";

import PagesIcon from "@/components/icons/PagesIcon";
import definedAbility from "@/ability";

export function fetchNavigationLinks(language) {
  const ability = definedAbility();

  return [
    {
      title: language.t("routes.home"),
      icon: mdiHomeOutline,
      to: "dashboard",
    },
    ability.can("view", "menu domains list") && {
      title: language.t("resources.domains.title"),
      icon: mdiWeb,
      to: "domains_list",
    },
    ability.can("view", "menu pages list") && {
      title: language.t("resources.pages.all_pages"),
      icon: PagesIcon,
      to: "pages_list",
    },
    ability.can("view", "menu ab tests list") && {
      title: language.t("resources.ab_tests.title"),
      icon: mdiArrangeBringForward,
      to: "ab_tests_list",
    },
    ability.can("view", "global alternative content") && {
      title: language.t("resources.alternative_contents.title"),
      icon: mdiViewDay,
      to: "alternative_contents_list",
    },
    ability.can("view", "calendars") && {
      title: language.t("resources.calendars.title"),
      icon: mdiCalendarMonthOutline,
      to: "calendars_list",
    },
    ability.can("view", "ai_tools") && {
      title: language.t("resources.ai_tools.title"),
      icon: mdiBrain,
      to: "ai_tools",
    },
    ability.can("view", "menu pages list") && {
      title: language.t("design_elements.title"),
      icon: mdiShapeOutline,
      to: "design_elements",
    },
    ability.can("view", "menu page elements") && {
      title: language.t("generic.page_elements_title"),
      hideBottomBar: ability.can("view", "form setup"),
      children: [
        {
          title: language.t("resources.headers.headers"),
          icon: mdiPageLayoutHeader,
          to: "headers_list",
        },
        {
          title: language.t("resources.footers.title"),
          icon: mdiPageLayoutFooter,
          to: "footers_list",
        },
        {
          title: language.t("resources.authors.authors"),
          icon: mdiAccountMultipleOutline,
          to: "authors_list",
        },
        {
          title: language.t("resources.popups.pop_ups"),
          icon: mdiDockWindow,
          to: "modals_list",
        },
        {
          title: language.t("resources.sidebars.title"),
          icon: mdiPageLayoutSidebarRight,
          to: "sidebars_list",
        },
        {
          title: language.t("resources.favorites_blocks.title"),
          icon: mdiViewGridOutline,
          to: "favorites_blocks_list",
        },
      ].filter(Boolean),
    },
    ability.can("view", "form setup") && {
      title: language.t("generic.page_data_title"),
      children: [
        ability.can("view", "form setup") && {
          title: language.t("resources.external_forms.title"),
          icon: mdiFormSelect,
          to: "external_forms_list",
        },
        ability.can("view", "phone numbers") && {
          title: language.t("resources.phone_numbers.title"),
          icon: mdiPhonePlus,
          to: "phone_numbers_list",
        },
      ].filter(Boolean),
    },
    {
      title: language.t("routes.meta_titles.settings"),
      icon: mdiCog,
      to: "settings",
    },
    ability.can("view", "menu help center") && {
      title: language.t("generic.help_center"),
      icon: mdiHelpBoxOutline,
      to: "https://help.siterunner.com/help",
    },
  ].filter(Boolean);
}
